import { omit, omitBy } from 'remeda';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type LeavePromptEntry = {
    /** The route match that shows the changes: leaving it asks */
    routeId: string;
    /** The path of that match: leaving it asks, opening a path below it doesn't */
    pathname: string;
    /** Search params the changes depend on: changing one asks */
    searchKeys: string[];
    /** Any change of path asks, opening a child route too */
    exact: boolean;
    /** The modal that shows the changes, if any */
    modalId?: string;
    messageKey?: string;
    /** Runs when the user leaves anyway */
    onLeave?: VoidFunction;
};

type LeavePromptStore = {
    entries: Record<string, LeavePromptEntry>;
    register: (id: string, entry: LeavePromptEntry) => void;
    unregister: (id: string) => void;
    unregisterModal: (modalId: string) => void;
};

export const useLeavePromptStore = create<LeavePromptStore>()(
    devtools(
        (set) => ({
            entries: {},
            register: (id, entry) =>
                set((state) => ({ entries: { ...state.entries, [id]: entry } }), false, 'register'),
            unregister: (id) =>
                set((state) => ({ entries: omit(state.entries, [id]) }), false, 'unregister'),
            unregisterModal: (modalId) =>
                set(
                    (state) => ({
                        entries: omitBy(state.entries, (entry) => entry.modalId === modalId),
                    }),
                    false,
                    'unregisterModal',
                ),
        }),
        { name: 'leavePromptStore' },
    ),
);
